export default __webpack_public_path__ + "21cdf3290d0f448d823677f955c3458c.png";